import React, { Component, Fragment } from 'react';

class PublishResult extends Component {
	publish() {
		const formData = new FormData();
		formData.append("data", this.state.data);

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'multipart/form-data' },
			body: formData
		};
		fetch('upload.cgi', requestOptions)
			.then(r => r.json())
			.then(data => {
				if (data["error"]) {
					this.setState({ result: { error: data["error"] } });
				} else {
					this.setState({ result: { url: data["url"] } });
				}
				console.log(data)
			});
	}

	render() {
		let circle_arr = [];
		let skip_arr = [];

		this.props.circles.forEach((c) => {
			circle_arr.push([c.gear, c.radius, c.offset * 180 / Math.PI]);
		});
		if (circle_arr.length === 0)
			return <></>;

		let state = true;
		let curr = [0, 0];
		this.props.points.forEach((p) => {
			if (p[2] !== state) {
				state = p[2];
				if (state === true) {
					skip_arr.push(curr);
					curr = [0, 0];
				}
			}
			if (state)
				curr[0]++;
			else
				curr[1]++;
		});
		skip_arr.push(curr);

		let content = {
			vectors: circle_arr,
			pen: skip_arr
		};
		let data = JSON.stringify(content);
		if (data !== this.state?.data)
			this.setState({ data: data, result: undefined });
		return (
			<>
				{
					this.state?.result?.url ?
						<>
							&nbsp;View standalone at <a href={this.state.result.url} target='_blank'>{this.state.result.url}</a>
						</>
						:
						<>
							<button onClick={() => this.publish()}>Publish standalone</button>
						</>
				}
			</>
		);
	}
}
export default PublishResult;